import { Sello } from '@/components/common/Sello';
import { NEGOCIO } from '@/lib/negocio';
/**
 * Cascarón visual compartido de las páginas públicas de cuenta (login-like):
 * logo + título centrados y una tarjeta con el contenido. Mismo estilo que Login.
 */
export function AuthShell({ title, subtitle, children }: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-full items-center justify-center bg-gradient-to-br from-brand-50 via-surface-muted to-brand-100 p-4 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <Sello nombre={NEGOCIO} grande />
          <p className="mt-3 text-sm font-semibold text-slate-600 dark:text-slate-300">{NEGOCIO}</p>
          <h1 className="mt-4 text-2xl font-bold text-slate-900 dark:text-slate-100">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">{subtitle}</p>}
        </div>
        <div className="rounded-xl border border-surface-border bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
          {children}
        </div>
      </div>
    </div>
  );
}
